export const CATEGORY_SALES_DATA = [
    { name: 'Ficción', sales: 4500 },
    { name: 'Ensayo', sales: 2100 },
    { name: 'Infantil', sales: 3200 },
    { name: 'Poesía', sales: 800 },
    { name: 'Técnico', sales: 1500 },
];